import moment from 'moment';
import React, { Dispatch, SetStateAction, useContext, useEffect, useState } from 'react';
import iconBack from '../../../../images/icon-chevron-left.svg';
import { AvailabilityRedirectionContext } from '../../../context/availabilityRedirection';
import styles from './AddAvailabilityForm.module.css';

interface addAvailabilityObj {
    locationId: string;
    unitId: string;
    locker: number;
    startDate: string;
    endDate: string;
    openingTime: string;
    closingTime: string;
    locationName: string;
    unitName: string;
}
interface props {
    setShowCalendar: (active: boolean) => void;
    setShowForm: (active: boolean) => void;
    setShowConfirm: (active: boolean) => void;
    addAvailabilityObj: addAvailabilityObj;
    setAddAvailabilityObj: Dispatch<SetStateAction<addAvailabilityObj>>;
    setShowToast?: React.Dispatch<React.SetStateAction<boolean>>;
    setToastMessage?: React.Dispatch<React.SetStateAction<string>>;
}

const AddAvailabilityForm = ({ setShowCalendar, setShowForm, setShowConfirm, addAvailabilityObj, setAddAvailabilityObj }: props) => {
    const availabilityRedirectionContext = useContext(AvailabilityRedirectionContext);

    useEffect(() => {
        if (
            (availabilityRedirectionContext?.availabilityData.slotRange && availabilityRedirectionContext?.availabilityData.locationName,
            availabilityRedirectionContext?.availabilityData.unitName)
        ) {
            const [openTime, closeTime] = availabilityRedirectionContext.availabilityData.slotRange.split(' -');
            setAddAvailabilityObj((prevState: any) => {
                return {
                    ...prevState,
                    openingTime: moment(openTime, 'hh:mm A').format('HH:mm'),
                    closingTime: moment(closeTime, 'hh:mm A').format('HH:mm'),
                    locationName: availabilityRedirectionContext.availabilityData.locationName,
                    unitName: availabilityRedirectionContext.availabilityData.unitName,
                };
            });
        }
    }, [availabilityRedirectionContext]);

    const [duration, setDuration] = useState({
        openingTime: '',
        closingTime: '',
    });

    const addAvailabilityHandler = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        if ((duration.closingTime ? duration : addAvailabilityObj).closingTime === '00:00') {
            (duration.closingTime ? duration : addAvailabilityObj).closingTime = '23:59';
        }

        setAddAvailabilityObj((prevState) => {
            return {
                ...prevState,
                openingTime: (duration.openingTime ? duration : addAvailabilityObj).openingTime,
                closingTime: (duration.closingTime ? duration : addAvailabilityObj).closingTime,
            };
        });
        setShowForm(false);
        setShowConfirm(true);
    };

    const onChangeEndTime = (e: React.FormEvent<HTMLInputElement>) => {
        const { value } = e.target as HTMLInputElement;

        const maxValue =
            moment(value, 'HH:mm').format('HH:mm') >= moment('23:01', 'HH:mm').format('HH:mm')
                ? '23:00'
                : moment(value, 'HH:mm').format('HH:mm');

        setDuration((prevState) => {
            return {
                ...prevState,
                closingTime: maxValue,
            };
        });
    };

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <div
                    className={styles.back}
                    onClick={() => {
                        setShowCalendar(true);
                        setShowForm(false);
                    }}>
                    <img src={iconBack} alt="back" />
                </div>
                <h2 className={styles.title}>Add Availability</h2>
            </div>
            <form onSubmit={addAvailabilityHandler} className={styles.body}>
                <div className={styles.fieldWrapper}>
                    <label>Property</label>
                    <div className={styles.field}>
                        <input value={addAvailabilityObj.locationName} type="text" name="location" disabled />
                    </div>
                </div>
                <div className={styles.fieldWrapper}>
                    <label>Unit</label>
                    <div className={styles.field}>
                        <input value={addAvailabilityObj.unitName} type="text" name="location" disabled />
                    </div>
                </div>
                <div className={styles.fieldWrapper}>
                    <label>Start Date</label>
                    <div className={styles.field}>
                        <input value={addAvailabilityObj.startDate} type="text" name="location" disabled />
                    </div>
                </div>
                <div className={styles.fieldWrapper}>
                    <label>End Date</label>
                    <div className={styles.field}>
                        <input value={addAvailabilityObj.endDate} type="text" name="location" disabled />
                    </div>
                </div>
                <div className={styles.fieldWrapper}>
                    <label>Opening Hours</label>
                    <div className={styles.field}>
                        <input
                            onChange={(e) => {
                                setDuration((prevState) => {
                                    return {
                                        ...prevState,
                                        openingTime: moment(e.target.value, 'HH:mm').format('HH:mm'),
                                    };
                                });
                            }}
                            required
                            type="time"
                            name="openingHours"
                            value={duration.openingTime ? duration.openingTime : addAvailabilityObj.openingTime}
                        />
                    </div>
                </div>
                <div className={styles.fieldWrapper}>
                    <label>Closing Hours</label>
                    <div className={styles.field}>
                        <input
                            onChange={(e) => onChangeEndTime(e)}
                            disabled={duration.openingTime === '' ? true : false}
                            required
                            type="time"
                            name="closingHours"
                            value={duration.closingTime ? duration.closingTime : addAvailabilityObj.closingTime}
                        />
                    </div>
                </div>
                <div className={styles.fieldWrapper}>
                    <label>Locker No</label>
                    <div className={styles.field}>
                        <input value={addAvailabilityObj.locker} type="text" name="location" disabled />
                    </div>
                </div>
                <div className={styles.submit}>
                    <button type="submit">Save</button>
                </div>
            </form>
        </div>
    );
};

export default AddAvailabilityForm;
